import React from 'react';

const TimelineItem = ({ title, isCompleted, isActive, onClick }) => (
  <div className="flex items-center mb-4 cursor-pointer group" onClick={onClick}>
    <div className="relative">
      <div 
        className={`w-3 h-3 rounded-full ${
          isActive 
            ? 'bg-purple-500 ring-2 ring-purple-300 dark:ring-purple-900' 
            : isCompleted
              ? 'bg-green-500'
              : 'bg-gray-300 dark:bg-gray-600'
        }`}
      />
      <div className="absolute top-3 left-1.5 w-0.5 h-8 -translate-x-1/2 bg-gray-200 dark:bg-gray-700" />
    </div>
    <span 
      className={`ml-4 text-sm transition-colors ${
        isActive 
          ? 'text-gray-900 dark:text-white font-medium' 
          : isCompleted
            ? 'text-green-600 dark:text-green-400'
            : 'text-gray-500 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white'
      }`}
    >
      {title}
    </span>
    {isCompleted && (
      <span className="ml-auto text-green-500">✓</span>
    )}
  </div>
);

export default TimelineItem;
